// @vendors
const Immutable = require('immutable');
const moment = require('moment');

// @constants
const actionTypes = require('../raConstants/actionTypes');
const {
    RA_SET_GOAL_MINIMUM_INVESTMENT_AMOUNT,
    CONTRIBUTION_PERIOD_MONTHLY,
    CONTRIBUTION_PERIOD_PUNCTUAL,
} = require('../raConstants/index');

// utilities
const { getDay, todayDate } = require('utilities/dateHelper');

const initialState = Immutable.fromJS({
    selectedAccountId: '',
    walletBalance: 0,
    selectedAccountError: false,
    selectedGoalDetail: {},
    investmentTitle: '',
    goalAmount: 0,
    goalAmountError: false,
    investmentDate: null,
    investmentDateError: false,
    recurringContributionAmount: 0,
    periodicity: CONTRIBUTION_PERIOD_MONTHLY,
    contributionDay: getDay(todayDate()),
    errorPeriodicityMin: false,
    prefilledData: false,
    showSignaturePattern: false,
    recurringValidationData: {},
    isFetching: false,
    submitSuccess: false,
    contributionFailure: false,
    portfolioName: '',
});

function setValues(key, value, state) {
    switch (key) {
        case 'goalAmount':
            const errorFlag =
                value !== 0 && value < RA_SET_GOAL_MINIMUM_INVESTMENT_AMOUNT;
            return state.merge({
                [key]: value,
                goalAmountError: errorFlag,
                showSignaturePattern: false,
            });
        case 'investmentDate':
            return state.merge({
                [key]: moment(value).startOf('day'),
                investmentDateError:
                    !value ||
                    value === 'Invalid date' ||
                    (value.isValid && !value.isValid()),
                showSignaturePattern: false,
            });
        case 'recurringContributionAmount':
            return state.merge({
                [key]: value,
                errorPeriodicityMin: value > 0 && value < 1,
                showSignaturePattern: false,
            });
        default:
            return state.merge({
                [key]: value,
                showSignaturePattern: false,
            });
    }
}

const RAAssociateObjective = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_ASSOCIATE_OBJECTIVE_SET_ACCOUNT:
            const { selectedAccountId, walletBalance } = action.payload;
            const periodicity = state.get('periodicity');
            return state.merge({
                selectedAccountId: selectedAccountId,
                walletBalance: walletBalance,
                selectedAccountError:
                    periodicity === CONTRIBUTION_PERIOD_PUNCTUAL &&
                    walletBalance < state.get('recurringContributionAmount'),
                showSignaturePattern: false,
            });
        case actionTypes.RA_UPDATE_SELECTED_GOAL:
            const selectedId = action.payload.goalSelected.id;
            const selectedGoalDetail = selectedId
                ? Immutable.fromJS(action.payload.goalSelected)
                : Immutable.fromJS({});
            if (selectedId === state.getIn(['selectedGoalDetail', 'id'])) {
                return state.set('selectedGoalDetail', Immutable.Map());
            } else {
                return state.merge({ selectedGoalDetail: selectedGoalDetail });
            }
        case actionTypes.RA_ASSOCIATE_OBJECTIVE_SET_VALUES:
            const { key, value } = action.payload;
            return setValues(key, value, state);
        case actionTypes.RA_ASSOCIATE_OBJECTIVE_RESET:
            return initialState;
        case actionTypes.RA_ASSOCIATE_OBJECTIVE_GET_SIGNATURE_PATTERN:
            return state.merge({
                showSignaturePattern: true,
            });
        case actionTypes.RA_ASSOCIATE_OBJECTIVE_TRANSFER_VALIDATION_SUCCESS:
            return state.merge({
                recurringValidationData: action.payload.response,
            });
        case actionTypes.RA_ASSOCIATE_OBJECTIVE_REQUEST:
            return state.merge({
                isFetching: true,
            });
        case actionTypes.RA_ASSOCIATE_OBJECTIVE_SUCCESS:
            return state.merge({
                submitSuccess: true,
                isFetching: false,
                contributionFailure: action.payload.contributionFailure,
            });
        default:
            return state;
    }
};

module.exports = RAAssociateObjective;
